import type {
  LocationRequestBody,
  LocationRequestResponse,
  ReportDecisionRequestBody,
  ReportDecisionResponse,
  ReportMediaListResponse,
  ReportRegistrationDetailResponse,
} from '@/domains/traffic-monitoring/types/report-registration.types';
import { request } from '@/shared/utils/request';

export const reportRegistrationApi = {
  // GET /api/dsh/report/{report_id} -> { report, patients[], ambulance_reports[], counts }
  getReportDetail: async (reportId: number): Promise<ReportRegistrationDetailResponse> => {
    return request.get<ReportRegistrationDetailResponse>(`/report/${reportId}`);
  },

  // GET /api/dsh/report/{report_id}/media -> { report_id, total_count, media_list[] }
  getReportMedia: async (reportId: number): Promise<ReportMediaListResponse> => {
    return request.get<ReportMediaListResponse>(`/report/${reportId}/media`);
  },

  // POST /api/dsh/report/{report_id}/decision -> { report_id, action, decided_time } | { conflict: true }
  postReportDecision: async (
    reportId: number,
    body: ReportDecisionRequestBody
  ): Promise<ReportDecisionResponse> => {
    return request.post<ReportDecisionResponse>(`/report/${reportId}/decision`, body);
  },

  // POST /api/dsh/report/{report_id}/location-request -> { link_url, expires_at, phone_number_masked, ... }
  postLocationRequest: async (
    reportId: number,
    body: LocationRequestBody = {}
  ): Promise<LocationRequestResponse> => {
    return request.post<LocationRequestResponse>(`/report/${reportId}/location-request`, body);
  },
};
